import React from 'react';
import ClubRegistration from '@/ui/components/tiles/ClubRegistration';
import { useTranslations } from 'next-intl';
import { useSearchParams } from 'next/navigation';
import { ScreenToShowState } from '@/ui/components/tiles/ClubRegistration/types/ScreenToShowState';

export type EmailInputProps = {
  question: string;
  subtext: string;
  buttonText?: string;
  skipText?: string;
  onSkip: () => void;
  onEmailSubmit: (email: string) => void;
  onGetResults: () => void;
};

export default function ICSubscribeInput(props: EmailInputProps) {
  const { question, subtext, buttonText, skipText, onSkip, onEmailSubmit, onGetResults } = props;
  const t = useTranslations('IC_Survey');

  const searchParams = useSearchParams();

  const isWelcomeScreen = searchParams.get('clubRegistrationStep') === ScreenToShowState.WELCOME;

  const clubTileStaticContent = {
    initialScreen: {
      title: question,
      subtitle: subtext,
      buttonText,
    },
    newAccountScreen: {
      title: question,
      subtitle: subtext,
      buttonText: t('Join & view results'),
    },
    existingAccountScreen: {
      title: question,
      subtitle: subtext,
      buttonText: t('Join & view results'),
    },
    welcomeMemberScreen: {
      title: t('Get your results via email'),
      subtitle: t('Click the button to receive your results via email'),
      buttonText: t('Get results now'),
    },
  };

  return (
    <div className="mx-auto flex h-full max-w-xl flex-col items-center justify-center text-center">
      <ClubRegistration
        staticContent={clubTileStaticContent}
        isInstallationCheck
        enableHistory
        onEmailSubmit={onEmailSubmit}
        onWelcomeScreenAction={onGetResults}
      />

      <div className="flex flex-grow" />

      {skipText && (
        <button
          type="button"
          onClick={onSkip}
          className="align-self-end my-4 justify-self-end  font-bold underline"
        >
          {isWelcomeScreen ? t('Skip') : skipText}
        </button>
      )}
    </div>
  );
}
